import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type { IGetDeshboardResponse } from "@/interface/dashboard.interface";
import type { IUserResponse } from "@/interface/user.model";

export const DashboardService = {
  getDashboard: async (date: string): Promise<IGetDeshboardResponse> => {
    const API = `${API_ENDPOINT?.getDashboard}?date=${date}`;
    return callApi<IGetDeshboardResponse>(API, { method: "GET" });
  },

  editProfile: async (
    userId: string,
    data: { tandcAccepted: boolean },
  ): Promise<IUserResponse> => {
    const API = `${API_ENDPOINT?.editProfile}?userId=${userId}`;

    return callApi<IUserResponse>(API, {
      method: "POST",
      data,
    });
  },
};
